export const WRENEV_GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.wrenev";
export const WRENEV_APP_STORE_LINK = "https://apps.apple.com/app/wrenev/id6450870668";

export const EVZONE_GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.evzone";
export const EVZONE_APP_STORE_LINK = "https://apps.apple.com/app/evzone-charge/id6498792195";

export const API = "https://wrenev.net/mobileapp/charge-point-connector-details";